import * as React from "react";
import { IFrame } from "@grandvisionhq/common";
import { compose } from "@grandvisionhq/utils";
import { withBreakpointVisibility } from "../../../../hocs/hocs/with-breakpoint-visibility.js";
import { withHidableContent } from "../../../../hocs/hocs/with-hidable-content.js";
import { withAnchor } from "../../../../hocs/hocs/with-anchor.js";
const CmsIframe = ({ component }) => {
  const { iframe: content } = component.getModels();
  if (!content) {
    return null;
  }
  const { source, scrolling, height, position, title } = content;
  if (!title) {
    console.error(
      `Cannot render iframe without a 'title'. Please update configuraton for iframe with source: ${source}`
    );
    return null;
  }
  return /* @__PURE__ */ React.createElement(
    IFrame,
    {
      source,
      scrolling,
      height,
      position,
      title
    }
  );
};
const CmsIframe$1 = compose(
  withBreakpointVisibility,
  withHidableContent,
  withAnchor
)(CmsIframe);
export {
  CmsIframe,
  CmsIframe$1 as default
};
//# sourceMappingURL=Iframe.js.map
